import React from 'react';
import { FormControl, FormLabel, Rating } from '@mui/material';

const RatingField = ({ label, value, onChange, disabled }) => {
  return (
    <FormControl
      component="fieldset"
      margin='normal'
      disabled={disabled}
      sx={{ width: "100%" }}
    >
      <FormLabel component="legend" sx={{
        color: "#c1cddb",

        ...(disabled && {
          color: "#a7bbcf !important",
        })

      }}>{label}

      </FormLabel>

      <Rating
        name={label}
        value={Number(value) || 0}
        onChange={(e, newValue) => onChange(newValue)}
        disabled={disabled}
        sx={{
          color: "white",
          marginTop: "5px",

          "& .MuiRating-iconFilled": {
            color: "white",
          },

          "& .MuiRating-iconEmpty": {
            color: "white",
          },

          "& .MuiRating-iconHover": {
            color: "gray",
          },

        }}
      />
    </FormControl>
  );
};

export default RatingField;